import {getCustomers} from '@/api/module/misc';
import {createVersionedStorage} from './types';

export const useCustomersStore = createVersionedStorage('customers', {
  fetchFn: () => getCustomers(),
  defaultFilters: {},
  defaultSorts: [],
  defaultData: [],
});
